import React from "react";
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, errorCode: error.message };
    }

    componentDidCatch(error, errorInfo) {
        localStorage.setItem('currentError', error);
        localStorage.setItem('currentErrorStack', errorInfo?.componentStack);
    }

    render() {
        if (this.state['hasError']) {
            return;
        }

        return this.props['children'];
    }
}